export const HHMM_12 = 'h:mma';
export const HHMM_24 = 'HH:mm';

export const TIME_FORMAT = {
  '12': HHMM_12,
  '24': HHMM_24,
};

export const HOUR_MINUTES_POSTFIXED_DATE_FORMAT = 'h[h] mm[m]';
export const HOUR_POSTFIXED_DATE_FORMAT = 'h[h]';
export const MINUTES_POSTFIXED_DATE_FORMAT = 'mm[m]';

export const UNRESTRICTED_FROM = '1970-01-01';
export const UNRESTRICTED_TO = '2100-01-01';
